import { Component, Directive, Input, Renderer2, ElementRef, AfterViewInit, ViewContainerRef, TemplateRef, ViewChild,
         HostBinding, ChangeDetectorRef } from '@angular/core';
export class TdMessageContainerDirective {
/**
 * @param {?} viewContainer
 */
constructor(public viewContainer: ViewContainerRef) { }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[tdMessageContainer]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
}

function TdMessageContainerDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdMessageContainerDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdMessageContainerDirective.ctorParameters;
/** @type {?} */
TdMessageContainerDirective.prototype.viewContainer;
}

export class TdMessageComponent implements AfterViewInit {
private _color: string;
private _opened: boolean = true;
private _initialized: boolean = false;

   _childElement: TdMessageContainerDirective;
   _template: TemplateRef<any>;
/**
 * @return {?}
 */
get hidden(): string {
    return !this._opened ? 'none' : undefined;
  }
/**
 * label: string
 * 
 * Sets the label of the message.
 */
label: string;
/**
 * sublabel?: string
 * 
 * Sets the sublabel of the message.
 */
sublabel: string;
/**
 * icon?: string
 * 
 * The icon to be displayed before the title.
 * Defaults to `info_outline` icon
 */
icon: string = 'info_outline';
/**
 * color?: primary | accent | warn
 * 
 * Sets the color of the message.
 * Can also use any material color: purple | light-blue, etc.
 * @param {?} color
 * @return {?}
 */
set color(color: string) {
    this._renderer.removeClass(this._elementRef.nativeElement, 'mat-' + this._color);
    this._renderer.removeClass(this._elementRef.nativeElement, 'bgc-' + this._color + '-100');
    this._renderer.removeClass(this._elementRef.nativeElement, 'tc-' + this._color + '-700');
    if (color === 'primary' || color === 'accent' || color === 'warn') {
      this._renderer.addClass(this._elementRef.nativeElement, 'mat-' + color);
    } else {
      this._renderer.addClass(this._elementRef.nativeElement, 'bgc-' + color + '-100');
      this._renderer.addClass(this._elementRef.nativeElement, 'tc-' + color + '-700');
    }
    this._color = color;
    this._changeDetectorRef.markForCheck();
  }
/**
 * @return {?}
 */
get color(): string {
    return this._color;
  }
/**
 * opened?: boolean
 * 
 * Shows or hiddes the message depending on its value.
 * Defaults to 'true'.
 * @param {?} opened
 * @return {?}
 */
set opened(opened: boolean) {
    if (this._initialized) {
      if (opened) {
        this.open();
      } else {
        this.close();
      }
    } else {
      this._opened = opened;
    }
  }
/**
 * @return {?}
 */
get opened(): boolean {
    return this._opened;
  }
/**
 * @param {?} _renderer
 * @param {?} _changeDetectorRef
 * @param {?} _elementRef
 */
constructor(private _renderer: Renderer2,
private _changeDetectorRef: ChangeDetectorRef,
private _elementRef: ElementRef) {
    this._renderer.addClass(this._elementRef.nativeElement, 'td-message');
  }
/**
 * Initializes the component and attaches the content if [opened] was true.
 * @return {?}
 */
ngAfterViewInit(): void {
    Promise.resolve(undefined).then(() => {
      if (this._opened) {
        this._childElement.viewContainer.createEmbeddedView(this._template);
        this._changeDetectorRef.markForCheck();
      }
      this._initialized = true;
    });
  }
/**
 * Renders the message on screen.
 * @return {?}
 */
open(): void {
    if (!this._opened) {
      this._opened = true;
      this._childElement.viewContainer.createEmbeddedView(this._template);
      this._changeDetectorRef.markForCheck();
    }
  }
/**
 * Removes the message content from screen.
 * @return {?}
 */
close(): void {
    if (this._opened) {
      this._opened = false;
      this._childElement.viewContainer.clear();
      this._changeDetectorRef.markForCheck();
    }
  }
/**
 * Toggles between open and close depending on state.
 * @return {?}
 */
toggle(): void {
    if (this._opened) {
      this.close();
    } else {
      this.open();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ChangeDetectorRef, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_childElement': [{ type: ViewChild, args: [TdMessageContainerDirective, ] },],
'_template': [{ type: ViewChild, args: [TemplateRef, ] },],
'hidden': [{ type: HostBinding, args: ['style.display', ] },],
'label': [{ type: Input, args: ['label', ] },],
'sublabel': [{ type: Input, args: ['sublabel', ] },],
'icon': [{ type: Input, args: ['icon', ] },],
'color': [{ type: Input, args: ['color', ] },],
'opened': [{ type: Input, args: ['opened', ] },],
};
}

function TdMessageComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdMessageComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdMessageComponent.ctorParameters;
/** @type {?} */
TdMessageComponent.propDecorators;
/** @type {?} */
TdMessageComponent.prototype._color;
/** @type {?} */
TdMessageComponent.prototype._opened;
/** @type {?} */
TdMessageComponent.prototype._initialized;
/** @type {?} */
TdMessageComponent.prototype._childElement;
/** @type {?} */
TdMessageComponent.prototype._template;
/**
 * label: string
 * 
 * Sets the label of the message.
 * @type {?}
 */
TdMessageComponent.prototype.label;
/**
 * sublabel?: string
 * 
 * Sets the sublabel of the message.
 * @type {?}
 */
TdMessageComponent.prototype.sublabel;
/**
 * icon?: string
 * 
 * The icon to be displayed before the title.
 * Defaults to `info_outline` icon
 * @type {?}
 */
TdMessageComponent.prototype.icon;
/** @type {?} */
TdMessageComponent.prototype._renderer;
/** @type {?} */
TdMessageComponent.prototype._changeDetectorRef;
/** @type {?} */
TdMessageComponent.prototype._elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
